export default {
  titles: {
    time: {
      count: {
        visit: 'Historique des visites HistoPad',
        collected_treasure_count: 'Historique des trésors trouvés',
        email: 'Historique des adresses emails recueillies',
        comment: 'Historique des commentaires',
        histomaton_file: 'Historique des HistoSelfies',
        affluence: "Historique des pics d'affluence",
        is_crash: 'Historique des crashs',
        upload: 'Historique des upload de logs',
        uploaded_time: 'Historique des upload de logs',
        uploaded_count: "Historique du nombre d'upload de logs",
        duplicate: 'Historique des visites dupliquées',
        hotspot: 'Historique des {0} consultés au cours du temps',
        cartel: 'Historique des {0} consultés au cours du temps',
        immersive: 'Historique des {0} consultés au cours du temps',
        augmentedvisit: 'Historique des {0} consultés au cours du temps',
        interactiveobject: 'Historique des {0} consultés au cours du temps',
        interactivebuilding: 'Historique des {0} consultés au cours du temps',
        interactivecharacter: 'Historique des {0} consultés au cours du temps',
        sequence: 'Historique des {0} consultés au cours du temps',
        email_delivered: 'Historique des emails after visit envoyés',
        email_open: 'Historique des ouvertures des emails after visit',
        email_click: 'Historique des clics dans les emails after visit',
        email_delivered_session: "Historique des visites ayant reçu l'email after visit",
        email_open_session: "Historique des visites ayant ouvert l'email after visit",
        email_click_session: "Historique des visites ayant cliqué l'email after visit",
        survey_answer: 'Historique du nombre de questionnaires commencés',
        route_duration: 'Historique de durée de visite',
        inactivity_time: "Historique de durée d'inactivité",
        area_visit: 'Historique du nombre de visite',
        stuck_log: 'Historique du nombre de logs bloqués',
        warning: 'Historique des warnings',
      },
      average_count: {
        visit: 'Historique du nombre moyen de visites HistoPad',
        email: "Historique du nombre moyen d'adresses emails recueillies",
        uploaded_time: 'Historique de la moyenne des upload de logs',
        comment: 'Historique du nombre moyen de commentaires laissées par les visiteurs',
        histomaton_file: "Historique du nombre moyen d'HistoSelfies",
        is_crash: 'Historique du nombre moyen de crashs',
        histopad_rating: 'Historique de la note moyenne HistoPad',
        visit_rating: 'Historique de la note moyenne de la visite',
        collected_treasure_count: 'Historique du nombre moyen de trésors trouvés',
        upload: "Historique du nombre moyen d'upload de logs",
        uploaded_count: "Historique du nombre moyen d'upload de logs",
        duplicate: 'Historique du nombre moyen de visites dupliquées',
        hotspot: 'Historique du nombre moyen de {0} consultés par visite',
        cartel: 'Historique du nombre moyen de {0} consultés par visite',
        immersive: 'Historique du nombre moyen de {0} consultés par visite',
        augmentedvisit: 'Historique du nombre moyen de {0} consultés par visite',
        interactiveobject: "Historique du nombre moyen d'{0} consultés par visite",
        interactivebuilding: "Historique du nombre moyen d'{0} consultés par visite",
        interactivecharacter: "Historique du nombre moyen d'{0} consultés par visite",
        sequence: "Historique du nombre moyen d'{0} consultés par visite",
        email_delivered: "Historique du nombre moyen d'emails after visit envoyés",
        email_open: "Historique du nombre moyen d'ouvertures d'emails after visit",
        email_click: 'Historique du nombre moyen de clics dans les emails after visit',
        survey_answer: 'Historique du nombre moyen de questionnaires commencés',
        rotation: 'Historique de la moyenne de rotations par histopad',
        route_duration: 'Historique de durée de visite',
        inactivity_time: "Historique de durée d'inactivité",
        area_visit: 'Historique du nombre moyen de visite',
        warning: 'Historique du nombre moyen de warnings',
        max_temperature: 'Historique de la moyenne de temperature max atteinte',
        min_temperature: 'Historique de la moyenne de temperature min atteinte',
        max_level: 'Historique de la moyenne de niveau de batterie max atteint',
        min_level: 'Historique de la moyenne de niveau de batterie min atteint',
        max_memory_level: 'Historique de la moyenne de la mémoire max atteinte',
        min_memory_level: 'Historique de la moyenne de la mémoire min atteinte',
        max_temperature_gradient: 'Historique de la moyenne du gradient max de temperature atteint',
        min_level_gradient: 'Historique de la moyenne du gradient min du niveau de battery atteint',
        max_memory_level_gradient: 'Historique de la moyenne du gradient max de mémoire atteint',
      },
      average_time: {
        visit: 'Historique du temps moyen de visite HistoPad',
        hotspot: 'Historique du temps moyen passé dans les {0} par visite',
        cartel: 'Historique du temps moyen passé dans les {0} par visite',
        immersive: 'Historique du temps moyen passé dans les {0} par visite',
        augmentedvisit: 'Historique du temps moyen passé dans les {0} par visite',
        interactiveobject: 'Historique du temps moyen passé dans les {0} par visite',
        interactivebuilding: 'Historique du temps moyen passé dans les {0} par visite',
        interactivecharacter: 'Historique du temps moyen passé dans les {0} par visite',
        sequence: 'Historique du temps moyen passé dans les {0} par visite',
        email_open: "Historique du temps moyen d'ouverture des emails after visit",
        route_duration: 'Historique de la durée moyenne de parcours',
        inactivity_time: "Historique de la durée moyenne d'inactivité",
        area_visit: 'Historique du temps moyen de visite',
      },
      max_time: {
        visit: 'Historique du temps maximum des visites',
      },
      min_time: {
        visit: 'Historique du temps mininum des visites',
      },
      percentage: {
        email: "Historique du pourcentage d'adresses emails recueillis",
        comment: 'Historique du pourcentage de visiteurs qui laissent un commentaire',
        histomaton_file: "Historique du pourcentage de visiteurs qui font l'HistoSelfies",
        is_crash: 'Historique du pourcentage de crashs',
        histopad_rating: 'Historique du pourcentage des visiteurs qui donnent une note HistoPad',
        visit_rating: 'Historique du pourcentage des visiteurs qui donnent une note à la visite',
        upload:
          "Historique du pourcentage du nombre d'upload de logs par rapport au nombre de sessions",
        uploaded_count: "Historique du pourcentage du nombre d'upload de logs",
        duplicate: 'Historique du pourcentage de visites dupliquées',
        collected_treasure_count: 'Historique du pourcentage de visites avec des trésors trouvés',
        email_delivered: "Historique du taux d'emails after visit envoyés",
        email_open: "Historique du taux d'ouvertures d'emails after visit",
        email_click: 'Historique du taux de clics dans les emails after visit',
        email_delivered_session:
          "Historique du pourcentage de visites ayant reçu l'email after visit",
        email_open_session: "Historique du pourcentage de visites ayant ouvert l'email after visit",
        email_click_session:
          "Historique du pourcentage de visites ayant cliqué dans l'email after visit",
        survey_answer:
          'Historique du pourcentage de questionnaires commencés sur le nombre de visite',
        route_duration: 'Historique du taux de temps de parcours sur le temps de visite',
        inactivity_time: "Historique du taux d'inactivitité",
        area_visit: 'Historique du pourcentage de visite',
        warning: 'Historique du pourcentage de visite avec des warnings',
      },
    },
    indicator: {
      count: {
        visit: 'Nombre de visites',
        collected_treasure_count: 'Nombre de trésors trouvés',
        email: "Nombre d'emails recueillis",
        comment: 'Nombre de commentaires recueillis',
        histomaton_file: "Nombre d'HistoSelfies recueillis",
        affluence: "Nombre de pics d'affluence",
        is_crash: 'Nombre de crash',
        upload: 'Nombre de logs uploadés',
        uploaded_time: 'Nombre de logs uploadés',
        uploaded_count: "Nombre d'upload de logs",
        duplicate: 'Nombre de visites dupliquées',
        hotspot: 'Nombre de {0} consultés',
        cartel: 'Nombre de {0} consultés',
        immersive: 'Nombre de {0} consultés',
        augmentedvisit: 'Nombre de {0} consultés',
        interactiveobject: 'Nombre de {0} consultés',
        interactivebuilding: 'Nombre de {0} consultés',
        interactivecharacter: 'Nombre de {0} consultés',
        sequence: 'Nombre de {0} consultés',
        email_delivered: "Nombre d'emails after visit envoyés",
        email_open: "Nombre d'ouvertures d'emails after visit",
        email_click: 'Nombre de clics dans les emails after visit',
        email_delivered_session: "Nombre de visites ayant reçu l'email after visit",
        email_open_session: "Nombre de visites ayant ouvert l'email after visit",
        email_click_session: "Nombre de visites ayant cliqué dans l'email after visit",
        survey_answer: 'Nombre de questionnaires commencés',
        area_visit: 'Nombre de visite',
        stuck_log: 'Nombre de logs bloqués',
        warning: 'Nombre de warnings',
      },
      average_count: {
        visit: 'Moyenne de visites',
        email: "Moyenne d'emails recueillis",
        comment: 'Moyenne de commentaires recueillis',
        histomaton_file: "Moyenne d'HistoSelfies recueillis",
        affluence: "Moyenne des pics d'affluence",
        is_crash: 'Moyenne de crash',
        upload: 'Moyenne de logs uploadés',
        uploaded_time: 'Moyenne de logs uploadés',
        uploaded_count: "Moyenne du nombre d'upload de logs",
        duplicate: 'Moyenne de visites dupliquées',
        histopad_rating: 'Moyenne de la note Histopad',
        visit_rating: 'Moyenne de la note de la visite',
        collected_treasure_count: 'Moyenne de trésor trouvés',
        hotspot: 'Moyenne de {0} consultés par visite',
        cartel: 'Moyenne de {0} consultés par visite',
        immersive: "Moyenne d'{0} consultés par visite",
        augmentedvisit: 'Moyenne de {0} consultés par visite',
        interactiveobject: "Moyenne d'{0} consultés par visite",
        interactivebuilding: "Moyenne d'{0} consultés par visite",
        interactivecharacter: "Moyenne d'{0} consultés par visite",
        sequence: "Moyenne d'{0} consultés par visite",
        email_delivered: "Moyenne d'emails after visit envoyés",
        email_open: "Moyenne d'ouvertures d'emails after visit",
        email_click: 'Moyenne de clics dans les emails after visit',
        email_delivered_session: "Moyenne des visites ayant reçu l'email after visit",
        email_open_session: "Moyenne des visites ayant ouvert l'email after visit",
        email_click_session: "Moyenne des visites ayant cliqué dans l'email after visit",
        survey_answer: 'Moyenne des questionnaires commencés',
        rotation: 'Moyenne de rotations par histopad utilisés',
        area_visit: 'Nombre moyen de visite',
        warning: 'Nombre moyen de warnings',
        max_temperature: 'Moyenne de temperature max atteinte',
        min_temperature: 'Moyenne de temperature min atteinte',
        max_level: 'Moyenne de niveau de batterie max atteint',
        min_level: 'Moyenne de niveau de batterie min atteint',
        max_memory_level: 'Moyenne de la mémoire max atteinte',
        min_memory_level: 'Moyenne de la mémoire min atteinte',
        max_temperature_gradient: 'Moyenne du gradient max de temperature atteint',
        min_level_gradient: 'Moyenne du gradient min du niveau de battery atteint',
        max_memory_level_gradient: 'Moyenne du gradient max de mémoire atteint',
      },
      average_time: {
        visit: 'Temps moyen de visite par jour',
        hotspot: 'Temps moyen passé dans les {0} par visite',
        cartel: 'Temps moyen passé dans les {0} par visite',
        immersive: 'Temps moyen passé dans les {0} par visite',
        augmentedvisit: 'Temps moyen passé dans les {0} par visite',
        interactiveobject: 'Temps moyen passé dans les {0} par visite',
        interactivebuilding: 'Temps moyen passé dans les {0} par visite',
        interactivecharacter: 'Temps moyen passé dans les {0} par visite',
        sequence: 'Temps moyen passé dans les {0} par visite',
        email_open: "Temps moyen d'ouverture des emails after visit",
        route_duration: 'Temps moyen de parcours',
        inactivity_time: "Temps moyen d'inactivité",
        area_visit: 'Temps moyen de visite',
      },
      max_time: {
        visit: 'Durée maximum des visites',
      },
      min_time: {
        visit: 'Durée minimum des visites',
      },
      percentage: {
        email: "Pourcentage d'emails recueillis",
        comment: 'Pourcentage de commentaires recueillis',
        histomaton_file: "Pourcentage d'HistoSelfies recueillis",
        is_crash: 'Pourcentage de crash',
        histopad_rating: 'Pourcentage de visite avec une note HistoPad',
        upload: "Pourcentage du nombre d'upload de logs par rapport au nombre de sessions",
        uploaded_count: "Pourcentage du nombre d'upload de logs",
        duplicate: 'Pourcentage de visites dupliquées',
        visit_rating: 'Pourcentage de visite avec une note',
        collected_treasure_count: 'Moyenne des trésors trouvés',
        email_delivered: "Pourcentage d'emails after visit envoyés",
        email_open: "Pourcentage d'ouvertures d'emails after visit",
        email_click: 'Pourcentage de clics dans les emails after visit',
        email_delivered_session: "Pourcentage des visites ayant reçu l'email after visit",
        email_open_session: "Pourcentage des visites ayant ouvert l'email after visit",
        email_click_session: "Pourcentage des visites ayant cliqué dans l'email after visit",
        survey_answer: 'Pourcentage de questionnaires commencés sur le nombre de visite',
        route_duration: 'Taux du temps de parcours sur le temps de visite',
        inactivity_time: "Taux d'inactivité pendant une visite",
        area_visit: 'Pourcentage de visite',
        warning: 'Pourcentage de visites avec des warnings',
      },
    },
    distribution: {
      visit: 'Répartition des visites',
      email: 'Répartition des visites avec email',
      comment: 'Répartition des visites avec commentaire',
      histomaton_file: 'Répartition des visites avec HistoSelfie',
      is_crash: 'Répartition des crashs',
      upload: 'Répartition des upload de logs',
      uploaded_time: 'Répartition des logs uploadés',
      uploaded_count: 'Répartition des duplicatas',
      duplicate: 'Répartition des visites dupliquées',
      collected_treasure_count: 'Répartition des trésors',
      email_delivered: 'Répartition des emails after visit envoyés',
      email_open: "Répartition des ouvertures d'emails after visit",
      email_click: 'Répartition du nombre de clics dans les emails after visit',
      email_delivered_session: "Répartition des visites ayant reçu l'email after visit",
      email_open_session: "Répartition des visites ayant ouvert l'email after visit",
      email_click_session: "Répartition des visites ayant cliqué dans l'email after visit",
      survey_answer: 'Répartition des questionnaires commencés',
      stuck_log: 'Répartition des logs bloqués',
      warning: 'Réparition des warnings',
    },
    day: {
      count: {
        visit: "Historique des visites HistoPad au cours d'une journée",
        email: "Historique des adresses emails recueillies au cours d'une journée",
        comment: "Historique des commentaires laissés au cours d'une journée",
        histomaton_file: "Historique des HistoSelfies au cours d'une journée",
        affluence: "Historique des pics d'affluence au cours d'une journée",
        is_crash: "Historique des crash au cours d'une journée",
        upload: "Historique des uploads de logs au cours d'une journée",
        uploaded_time: "Historique des logs uploadés au cours d'une journée",
      },
    },
    rotation: {
      count: {
        visit: 'Nombre de rotations par tablette',
        email: 'Nombre de rotations avec email laissé par tablette',
        comment: 'Nombre de rotations avec commentaire laissé par tablette',
        histomaton_file: 'Nombre de rotations avec HistoSelfie par tablette',
        is_crash: 'Nombre de crashs par tablette',
      },
    },
    matrix: {
      count: {
        affluence: "Heatmap de l'affluence des visiteurs au cours du temps",
      },
    },
  },
}
